import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getAccessToken,
  clearAccessToken,
  getAdminUsers,
  getAdminStats,
} from "../utils/fetchFunctions";
import { getUserRole } from "../utils/jwtUtils";

import "./dashboardAdmin.css";

export default function DashboardAdmin() {
  const [users, setUsers] = useState([]);
  const [totalAnsweredUsers, setTotalAnsweredUsers] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const token = getAccessToken();

    if (!token) {
      navigate("/login");
      return;
    }

    const role = getUserRole();
    if (role !== "admin") {
      navigate("/dashboard");
      return;
    }

    const loadUsers = async () => {
      setLoading(true);
      setError("");

      try {
        const usersData = await getAdminUsers();
        setUsers(usersData);
      } catch (err) {
        if (String(err).includes("401")) {
          clearAccessToken();
          navigate("/login");
          return;
        }
        if (String(err).includes("403")) {
          navigate("/dashboard");
          return;
        }

        setError(err.message || "Error loading users");
      } finally {
        setLoading(false);
      }
    };

    const loadStats = async () => {
      try {
        const statsData = await getAdminStats();
        setTotalAnsweredUsers(statsData.totalAnsweredUsers);
      } catch (err) {
        console.error("Error fetching stats:", err);
      }
    };

    loadUsers();
    loadStats();
  }, [navigate]);

  if (loading) {
    return (
      <div className="admin-dashboard-page">
        <div className="admin-dashboard-card">
          <h1 className="admin-dashboard-title">Admin Dashboard</h1>
          <p className="admin-dashboard-subtitle">Loading data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-dashboard-page">
      <div className="admin-dashboard-card">
        <h1 className="admin-dashboard-title">Admin Dashboard</h1>

        <p
          className="admin-dashboard-subtitle"
          style={{ color: "var(--secondary-color)" }}
        >
          Overview of all registered users
        </p>

        <p className="admin-dashboard-stats">
          Number of users who have completed the questionnaire:{" "}
          <strong>{totalAnsweredUsers}</strong>
        </p>

        {error && (
          <p
            className="admin-dashboard-info"
            style={{ color: "var(--error-color)" }}
          >
            {error}
          </p>
        )}

        <div className="admin-dashboard-table-wrapper">
          {users.length > 0 ? (
            <table className="admin-dashboard-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Email</th>
                  <th>Company Name</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                {users.map((user) => (
                  <tr key={user.id}>
                    <td>{user.id}</td>
                    <td>{user.email}</td>
                    <td>{user.companyName || "-"}</td>
                    <td>
                      <span
                        className={
                          user.status === "active"
                            ? "admin-dashboard-status-badge admin-dashboard-status-badge--active"
                            : "admin-dashboard-status-badge admin-dashboard-status-badge--inactive"
                        }
                      >
                        {user.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="admin-dashboard-info">No users found.</p>
          )}
        </div>
      </div>
    </div>
  );
}
